/**
 * Display application version number on lobby screen
 */
export class AppVersionNumber extends Phaser.GameObjects.Container
{
    public label:Phaser.GameObjects.Text;
    private labelText: string;
    private labelStyle: Phaser.Types.GameObjects.Text.TextStyle;

    constructor(scene: Phaser.Scene, x?: number, y?: number)
    {
        super(scene, x, y);
    }

    public Init(text:string, style: Phaser.Types.GameObjects.Text.TextStyle): AppVersionNumber
    {
        this.labelText = text;
        this.labelStyle = style;

        return this;
    }

    public Build(): AppVersionNumber
    {
        this.label = this.scene.add.text(0, 0, this.labelText, this.labelStyle);
        // console.log(this.label.style.metrics); // { ascent: 25, descent: 6, fontSize: 31 }
        this.label.setOrigin(1);
        this.add(this.label);

        return this;
    }

    public destroy(): void
    {
        // console.log("AppVersionNumber::destroy")
        
        this.label.destroy();
        
        this.label = null;
        this.labelText = null;
        this.labelStyle = null;
    }
}